export const initialCryptoPrices = {
  BTC: {
    bid: 52174.2715,
    ask: 52174.3265,
  },
  ETH: {
    bid: 2792.8138,
    ask: 2792.8145,
  },
  USDT: {
    bid: 1.0001,
    ask: 1.0004,
  },
  BNB: {
    bid: 359.4748,
    ask: 359.4762,
  },
  SOL: {
    bid: 109.2015,
    ask: 109.2025,
  },
  XRP: {
    bid: 0.5599,
    ask: 0.5611,
  },
  USDC: {
    bid: 1.0001,
    ask: 1.0002,
  },
  ADA: {
    bid: 0.5919,
    ask: 0.5926,
  },
  DOGE: {
    bid: 0.0853,
    ask: 0.0856,
  },
  WBTC: {
    bid: 52040.2016,
    ask: 52040.2022,
  },
  BHC: {
    bid: 272.7315,
    ask: 272.7328,
  },
  LTC: {
    bid: 69.6671,
    ask: 69.6676,
  },
  ETC: {
    bid: 26.6341,
    ask: 26.6384,
  },
  XMR: {
    bid: 125.3879,
    ask: 125.3888,
  },
};
